/**
 * Interactive HTML Components
 *
 * Export all interactive HTML components and utilities
 */

export { InteractiveHtmlRenderer } from './InteractiveHtmlRenderer';
export { default as InteractiveHtml } from './InteractiveHtmlRenderer';

// Export modal context
export { ModalProvider, useModal } from './ModalContext';
export type { ModalConfig as ModalContextConfig } from './ModalContext';

// Export types
export type {
  InteractiveType,
  ModalConfig,
  FaqConfig,
  FaqItemData,
  SliderConfig,
  SliderItemData,
  TabsConfig,
  TabData,
  ExpandableConfig,
} from './types';

// Export individual components (if needed)
export { ModalTrigger } from './components/ModalTrigger';
export { FaqAccordion } from './components/FaqAccordion';
export { InteractiveSlider } from './components/InteractiveSlider';
export { TabsContainer } from './components/TabsContainer';
export { ExpandableSection } from './components/ExpandableSection';

// Export transform
export { interactiveHtmlTransform } from './transform';
